import { render, staticRenderFns } from "./ActionCard.vue?vue&type=template&id=04135a29&scoped=true"
import script from "./ActionCard.vue?vue&type=script&lang=js"
export * from "./ActionCard.vue?vue&type=script&lang=js"
import style0 from "./ActionCard.vue?vue&type=style&index=0&id=04135a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04135a29",
  null
  
)

export default component.exports